module.exports = __webpack_public_path__ + "img/Fusion360.f4ffb35a.png";